// Shared constants for the public widget.

// Version of the consent wording the user accepted (stored for provability).
// Bump whenever the legal text in ConsentBlock changes.
export const CONSENT_TEXT_VERSION = 'v3-2026-06';

// Version of the extra AI-call consent (Pfad B). Collected only when the user
// actively chooses to be called by the AI phone system. Bump on wording change.
export const AI_CONSENT_TEXT_VERSION = 'ai-v1-2026-06';

// Default booking horizon for the slot picker: only the next two weeks are
// offered. The summer-holiday advance-booking window may override this later.
export const BOOKING_WINDOW_DAYS = 14;

export const WEEKDAYS = ['', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag', 'Sonntag'];

// Die Länder-Vorwahlen für das Telefonfeld stehen in `lib/telefon.ts` — dort,
// wo auch die Nummer zusammengesetzt wird.

// Confirmed Datenschutz link of the main site (Konrad). NOTE: the consent
// WORDING itself is still a placeholder pending the DSGVO/eRecht24 review.
export const PRIVACY_URL = 'https://randori-pro.de/datenschutz/';

// Target page shared via the „Freunde informieren" buttons on the confirmation
// screen. Override per deployment with VITE_SHARE_URL; defaults to the main site.
export const SHARE_URL = import.meta.env.VITE_SHARE_URL || 'https://randori-pro.de/';
export const SHARE_TEXT = 'Mach mit mir ein kostenloses Probetraining bei Randori-Pro! 🥋';
